import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'

import { Container } from './dropzone.component.styles'
import { SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'

const Dropzone = ({
  children,
  fileType,
  handleFileUpload = async () => {},
  handleRejected = () => {},
  loading = false,
  maxFiles = 1,
  maxSize = 2 * 1024 * 1024,
  height,
  width,
  customLoadingIndicator,
}) => {
  const [uploadedFiles, setUploadedFiles] = useState([])

  const onDropAccepted = useCallback(
    async (acceptedFiles, dropEvent) => {
      try {
        await handleFileUpload(
          { target: { files: acceptedFiles } },
          dropEvent?.type
        )
        setUploadedFiles([...uploadedFiles, ...acceptedFiles])
      } catch (error) {
        handleRejected(acceptedFiles, dropEvent?.type)
        setUploadedFiles([])
      }
    },
    [handleFileUpload, uploadedFiles, handleRejected]
  )

  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject,
    open,
  } = useDropzone({
    noClick: true,
    noKeyboard: true,
    accept: fileType,
    onDropAccepted,
    onDropRejected: (file, dropEvent) => handleRejected(file, dropEvent?.type),
    maxFiles,
    maxSize,
  })

  const handleOnClick = event => {
    event.preventDefault()
    open()
  }

  return (
    <Container
      height={height}
      width={width}
      {...getRootProps({ isDragAccept, isDragReject })}
    >
      <input {...getInputProps()} />
      {loading && (customLoadingIndicator || <SmallText>Loading...</SmallText>)}
      {!loading &&
        uploadedFiles.length === 0 &&
        React.cloneElement(children, { open: handleOnClick })}
    </Container>
  )
}

Dropzone.propTypes = {
  children: PropTypes.node,
  fileType: PropTypes.string,
  handleFileUpload: PropTypes.func,
  handleRejected: PropTypes.func,
  loading: PropTypes.bool,
  maxFiles: PropTypes.number,
  maxSize: PropTypes.number,
  height: PropTypes.string,
  width: PropTypes.string,
  customLoadingIndicator: PropTypes.node,
}

export { Dropzone }
